module.exports = __webpack_public_path__ + "static/media/criteria-2.2-rsp.525f7bfa.jpg";